<p-steps
  [model]="translatedSteps"
  [activeIndex]="activeIndex"
  [ngClass]="{ 'vertical-direction': direction === 'vertical' }"
  [readonly]="readonly"
  (activeIndexChange)="onActiveIndexChange($event)"
></p-steps>
